import { useMemo, type ReactNode } from 'react';
import { MessagingProvider } from '@gokrew/ui';
import { tokenManager } from '@/auth';
import { createMessagingApi, messagingSocketUrl } from '@/api/messaging';
import { useEmployeePortalAuth } from '@/context/EmployeeAuthContext';
export const MessagingSession = ({ children }: { children: ReactNode }) => {
  const { user } = useEmployeePortalAuth();
  // The personal-profile endpoint can return the joined company without
  // its flat foreign key.
  const companyId = user?.companyId ?? user?.company?.id;
  const userId = user?.user?.id ?? user?.userId;
  const api = useMemo(() => createMessagingApi(companyId ?? ''), [companyId]);
  return (
    <MessagingProvider
      key={`${companyId}:${userId}`}
      api={api}
      companyId={companyId}
      userId={userId}
      portal="employee"
      socketUrl={messagingSocketUrl()}
      getToken={tokenManager.getValidToken}
      refreshToken={tokenManager.forceRefresh}
    >
      {children}
    </MessagingProvider>
  );
};
